<template>
  <div class="product-list-container">
    <ul class="list">
      <li v-for="(product, index) in vendorProducts" :key="`${product.internalName}-${index}`">
        <slot :product="product"></slot>
      </li>
    </ul>
    <div v-show="isProtectionCategory && genericProducts.length !== 0" class="general-protection-information">
      <h4>{{ $t('message.spotlightV2.general-protection-information.title') }}</h4>
      <p class="general-protection-description">
        {{ $t('message.spotlightV2.general-protection-information.description') }}
      </p>
    </div>
    <ul class="list">
      <li v-for="(product, index) in genericProducts" :key="`${product.internalName}-${index}`">
        <slot :product="product"></slot>
      </li>
    </ul>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import { spotlightMixin } from '@/mixins';

export default {
  name: 'SpotlightProductList',
  mixins: [spotlightMixin],
  props: {
    productList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isProtectionCategory() {
      return this.getSelectedSpotlightCategory() === 'protection';
    },
    vendorProducts() {
      const unsortedProductList = this.productList;
      let sameVendorProducts = [];
      let otherVendorProducts = [];

      for (let i = 0; i < unsortedProductList.length; i += 1) {
        // Remove generic AutoVerify products
        if (unsortedProductList[i].internalName.includes('autoverify_')) {
          // eslint-disable-next-line no-continue
          continue;
        }

        // Want products of similar vendor at the top
        if (
          this.getSelectedSpotlightProduct() &&
          this.getSelectedSpotlightProduct().vendor.name === unsortedProductList[i].vendor.name
        ) {
          sameVendorProducts.push(unsortedProductList[i]);
        } else {
          otherVendorProducts.push(unsortedProductList[i]);
        }
      }

      // Sort both lists in alphabetical order based on product name
      sameVendorProducts = sortBy(sameVendorProducts, ['payload[product]']);
      otherVendorProducts = sortBy(otherVendorProducts, ['payload[product]']);

      return [...sameVendorProducts, ...otherVendorProducts];
    },
    genericProducts() {
      const unsortedProductList = this.productList;
      let genericProducts = [];
      for (let i = 0; i < unsortedProductList.length; i += 1) {
        if (unsortedProductList[i].internalName.includes('autoverify_')) {
          genericProducts.push(unsortedProductList[i]);
        }
      }
      genericProducts = sortBy(genericProducts, ['payload[product]']);
      return genericProducts;
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding: 0;
}
.general-protection-information {
  padding: 10px 10px 20px 10px;
}
.line-break {
  margin-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid rgb(218, 226, 234);
}
</style>
